// ABOUTME: The placeholder drawn while one application loads: the card block, then the timeline block underneath.
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const ApplicationSkeleton = () => (
  <Box data-testid="application-skeleton">
    <Skeleton variant="rounded" height={260} sx={{ borderRadius: 4, mb: 2 }} />
    <Skeleton variant="rounded" height={180} sx={{ borderRadius: 4 }} />
  </Box>
);
